<template>
  <v-row class="unauthorized-split-display">
    <v-col lg="6" class="bg-polygon">
      <img
        src="https://user-images.githubusercontent.com/46636890/145160915-3f87ab37-3636-4c5e-a1ba-102951bb4058.png"
      />
      <div class="transparent-wrapper">
        <h1>Journal of Materials & Environmental Sustainability Research</h1>
        <h2 class="mb-5">Manuscript Submission System</h2>
        <v-btn :href="journalURL" color="white" large>
          Visit Journal Homepage
        </v-btn>
      </div>
    </v-col>

    <v-col>
      <v-card max-width="410px" class="login-wrapper">
        <div class="pa-5 d-flex align-items-center">
          <v-spacer></v-spacer>
          <v-img
            class="shrink mr-2"
            contain
            src="https://www.iceesr.org.ng/favicon.png"
            transition="scale-transition"
            width="46"
          />
        </div>
        <h3 class="py-1 text-center green accent-4 white--text text-uppercase">
          Login
        </h3>
        <v-card class="px-5 py-8" color="basil" flat>
          <v-form
            class="mr-2 mt-4"
            v-model="valid"
            @submit.prevent="authenticate"
          >
            <v-text-field
              outlined
              label="Email *"
              prepend-icon="mdi-at"
              :rules="rules.required"
              validate-on-blur
              v-model="email"
            ></v-text-field>

            <v-text-field
              outlined
              label="Password *"
              prepend-icon="mdi-lock-outline"
              :rules="rules.required"
              v-model="password"
              validate-on-blur
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <div class="ml-8">
              <p class="mb-7">* mark required fields.</p>
              <v-btn
                color="green"
                type="submit"
                class="white--text mr-2"
                :disabled="!valid || loading"
                :loading="loading"
              >
                Login
              </v-btn>
              <v-btn color="green" text to="/register"> Register </v-btn>
            </div>

            <div class="ml-8">
              <v-divider class="my-5"></v-divider>
              <v-btn text small color="grey darken-3" to="/forgot-password">
                Forgot password
              </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { required } from "../../tools/rules";

export default {
  data: () => ({
    valid: false,
    showPassword: false,
    rules: {
      required,
    },

    email: null,
    password: null,
    loading: false,

    journalURL: process.env.VUE_APP_JOURNAL_URL,
  }),

  methods: {
    authenticate() {
      this.loading = true;
      this.$axios
        .post("/login", { email: this.email, password: this.password })
        .then(({ data: response }) => {
          const { token, user } = response;
          localStorage.setItem("jmesrUser", JSON.stringify(user));
          localStorage.setItem("jmesrToken", token);
          localStorage.setItem("jmesrAuth", "true");

          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Login successful",
          });

          this.$bus.$emit("login");
          let searchParams = new URLSearchParams(window.location.search);

          if (searchParams.has("redirect")) {
            this.$router.push({ path: `${searchParams.get("redirect")}` });
          } else {
            this.$router.push({ name: "dashboard" });
          }
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Bad credentials",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.unauthorized-split-display {
  .login-wrapper {
    margin: 8% 13% 5% auto;
  }
}

@media screen and (max-width: 480px) {
  .unauthorized-split-display {
    .login-wrapper {
      margin: 0 0.75em 10%;
    }
  }
}
</style>